var UserRole;
(function (UserRole) {
    UserRole[UserRole["ADMIN"] = 1] = "ADMIN";
    UserRole[UserRole["PROVIDER"] = 2] = "PROVIDER";
    UserRole[UserRole["PHYSICIAN_ASSISTANT"] = 3] = "PHYSICIAN_ASSISTANT";
    UserRole[UserRole["CLINICAL_ASSISTANT"] = 4] = "CLINICAL_ASSISTANT";
    UserRole[UserRole["OFFICE_STAFF"] = 5] = "OFFICE_STAFF";
    UserRole[UserRole["BILLER"] = 6] = "BILLER";
    UserRole[UserRole["BUSINESS_MANAGER"] = 7] = "BUSINESS_MANAGER";
})(UserRole || (UserRole = {}));
export default UserRole;
